import contractClaimTranslations from "./contractClaimTranslations";

const travelContract = {
  ...contractClaimTranslations,
  label: "Reisevertrag",
  reasonForDispute: {
    label: "Problem des Kunden",
    values: {
      cancelled: "Die Reise wurde abgesagt",
      participationImpossible: "Konnte nicht teilnehmen",
      notAsAdvertised: "Nicht wie beschrieben",
      other: "Sonstiges",
    },
  },
  contractNumber: {
    label: "Buchungsnummer",
  },
  bookingDate: {
    label: "Buchungsdatum",
  },
  journeyStart: {
    label: "Start der Reise am",
  },
  journeyEnd: {
    label: "Ende der Reise am",
  },
  contractualPartnerHasCancelled: {
    label: "Absage durch Reiseanbieter",
    values: {
      true: "Ja",
      false: "Nein",
    },
  },
  contractualPartnerCancellationDate: {
    label: "Absage am",
  },
};

export default travelContract;
